<div class="body xxxxx">
    <router-outlet></router-outlet>
</div>